import type { FC } from 'react';
import type { CustomIconProps } from '../types';

const ShipsFast: FC<CustomIconProps> = ({ width, height }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? '32'}
        height={height ?? '32'}
        viewBox="0 0 32 32"
        fill="none"
    >
        <path
            fill="#414042"
            fillRule="evenodd"
            d="M13.072 7.735a10.034 10.034 0 0 1 5.053-1.353C23.578 6.382 28 10.688 28 16s-4.422 9.618-9.875 9.618c-1.298 0-2.54-.244-3.677-.689a.912.912 0 0 1-.524-1.195.953.953 0 0 1 1.227-.511 8.15 8.15 0 0 0 2.974.556c4.41 0 7.987-3.483 7.987-7.779 0-4.296-3.576-7.78-7.987-7.78a8.107 8.107 0 0 0-4.086 1.094.958.958 0 0 1-1.294-.319.906.906 0 0 1 .327-1.26Zm4.724 2.007c.49 0 .888.397.888.887v4.596l2.444 1.834a.888.888 0 1 1-1.065 1.42l-2.8-2.1a.888.888 0 0 1-.355-.71v-5.04c0-.49.398-.887.888-.887Zm-9.548 8.526a.888.888 0 0 0 0 1.776h6.72a.888.888 0 0 0 0-1.776h-6.72ZM5.68 15.796c0-.49.397-.888.888-.888h6.72a.888.888 0 1 1 0 1.776h-6.72a.888.888 0 0 1-.888-.888Zm-.792-4.247a.888.888 0 0 0 0 1.775h6.72a.888.888 0 1 0 0-1.775h-6.72Z"
            clipRule="evenodd"
        />
    </svg>
);

export default ShipsFast;
